/**
 * In-memory "last time the user opened the job history page" timestamp.
 *
 * PRD-001 DoD: "A persistent badge / count in the app's primary navigation
 * surfaces jobs that have transitioned to a terminal state (`succeeded`,
 * `failed`, `cancelled`) since the user last viewed the job history page.
 * The count clears when the user opens the history page."
 *
 * Persistence model: in-memory only, mirroring the closure-store pattern
 * in `auth/jwtStore.ts` and `project/projectStore.ts`. A page refresh or
 * tab close resets the high-water mark to "now" — meaning the badge
 * starts at zero on a fresh session, which is the correct UX (a brand-new
 * tab has nothing to "have seen" yet).
 */

let lastViewedAt: number = Date.now();
const listeners = new Set<() => void>();

function notify() {
    for (const fn of listeners) fn();
}

export const jobsViewedStore = {
    getLastViewedAt(): number {
        return lastViewedAt;
    },
    markViewedNow(): void {
        lastViewedAt = Date.now();
        notify();
    },
    subscribe(fn: () => void): () => void {
        listeners.add(fn);
        return () => {
            listeners.delete(fn);
        };
    },
};

/** Test-only reset. */
export function __resetJobsViewedStoreForTests(): void {
    lastViewedAt = Date.now();
    listeners.clear();
}
